import React from 'react'
import PropTypes from 'prop-types'
import { MenuItem, MenuList } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router-dom'

export default function CustomMenuList({
  openMenu,
  closeMenu,
  parentLink,
  links,
  onClick,
}) {
  const navigate = useNavigate()
  const loc = useLocation()
  const goLocation = (link) => {
    onClick?.()
    const goLink = `${parentLink.to}${link ? '/' : ''}${link}`
    if (loc.pathname === goLink) {
      location.reload()
    } else {
      navigate(goLink)
    }
    closeMenu()
  }
  return (
    <MenuList
      position="relative"
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
    >
      {links.map((item) => (
        <MenuItem onClick={() => goLocation(item.to)} key={item.label}>
          {item.label}
        </MenuItem>
      ))}
    </MenuList>
  )
}

CustomMenuList.propTypes = {
  closeMenu: PropTypes.func,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      to: PropTypes.string,
    }),
  ),
  onClick: PropTypes.func,
  openMenu: PropTypes.func,
  parentLink: PropTypes.shape({
    to: PropTypes.string,
  }),
}
